// Global Instructions Rule Applied!
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'

/**
 * Mobile top bar: an optional history-aware back button on the left and a centred
 * screen title. Sticky to the top, with safe-area padding for the notch / Dynamic
 * Island (the `.safe-*` helpers were landed in Phase 0).
 */
export function MobileTopBar({ title, showBack }: { title: string; showBack: boolean }): React.JSX.Element {
  const navigate = useNavigate()
  return (
    <header
      className="safe-pt safe-pl safe-pr"
      style={{ position: 'sticky', top: 0, zIndex: 20, background: '#fff', borderBottom: '1px solid #f0f0f0' }}
    >
      <div style={{ height: 52, display: 'flex', alignItems: 'center', position: 'relative' }}>
        {showBack ? (
          <button
            type="button"
            aria-label="Back"
            onClick={() => navigate(-1)}
            style={{
              border: 'none',
              background: 'transparent',
              padding: '8px 12px',
              cursor: 'pointer',
              color: '#1890ff',
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              fontSize: 16
            }}
          >
            <FontAwesomeIcon icon={faChevronLeft} />
            <span>Back</span>
          </button>
        ) : null}
        <div
          style={{
            position: 'absolute',
            left: 0,
            right: 0,
            textAlign: 'center',
            padding: '0 76px',
            pointerEvents: 'none',
            fontWeight: 600,
            fontSize: 16,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}
        >
          {title}
        </div>
      </div>
    </header>
  )
}

export default MobileTopBar
